export default "__VITE_ASSET__Co$8HkMk__"